// extracted by css-extract-rspack-plugin
export default {"eventKeyInput":"Tomjesv4A3cslD15","eventActivityContainer":"lD6J_k1278sn9RgC","eventActivityContainerNewWidth":"ha2vWdugMNI8QKuq","tooltipContainer":"d8co0gh9MdkKoVB2"};